// source: talk-api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
goog.object.extend(proto, google_protobuf_any_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.talk_api.AssistantConversationAssistantMessage', null, global);
goog.exportSymbol('proto.talk_api.AssistantConversationConfiguration', null, global);
goog.exportSymbol('proto.talk_api.AssistantConversationInterruption', null, global);
goog.exportSymbol('proto.talk_api.AssistantConversationInterruption.InterruptionType', null, global);
goog.exportSymbol('proto.talk_api.AssistantConversationUserMessage', null, global);
goog.exportSymbol('proto.talk_api.AssistantDefinition', null, global);
goog.exportSymbol('proto.talk_api.AssistantMessagingRequest', null, global);
goog.exportSymbol('proto.talk_api.AssistantMessagingResponse', null, global);
goog.exportSymbol('proto.talk_api.AssistantMessagingResponse.DataCase', null, global);
goog.exportSymbol('proto.talk_api.CreateConversationMetricRequest', null, global);
goog.exportSymbol('proto.talk_api.CreateConversationMetricResponse', null, global);
goog.exportSymbol('proto.talk_api.CreateMessageMetricRequest', null, global);
goog.exportSymbol('proto.talk_api.CreateMessageMetricResponse', null, global);
goog.exportSymbol('proto.talk_api.InitiateAssistantTalkParameter', null, global);
goog.exportSymbol('proto.talk_api.InitiateAssistantTalkRequest', null, global);
goog.exportSymbol('proto.talk_api.InitiateAssistantTalkResponse', null, global);
goog.exportSymbol('proto.talk_api.InitiateBulkAssistantTalkRequest', null, global);
goog.exportSymbol('proto.talk_api.InitiateBulkAssistantTalkResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.AssistantDefinition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.AssistantDefinition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.AssistantDefinition.displayName = 'proto.talk_api.AssistantDefinition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.AssistantMessagingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.AssistantMessagingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.AssistantMessagingRequest.displayName = 'proto.talk_api.AssistantMessagingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.AssistantConversationConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.AssistantConversationConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.AssistantConversationConfiguration.displayName = 'proto.talk_api.AssistantConversationConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.AssistantConversationInterruption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.AssistantConversationInterruption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.AssistantConversationInterruption.displayName = 'proto.talk_api.AssistantConversationInterruption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.AssistantConversationUserMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.AssistantConversationUserMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.AssistantConversationUserMessage.displayName = 'proto.talk_api.AssistantConversationUserMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.AssistantConversationAssistantMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.AssistantConversationAssistantMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.AssistantConversationAssistantMessage.displayName = 'proto.talk_api.AssistantConversationAssistantMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.AssistantMessagingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.talk_api.AssistantMessagingResponse.oneofGroups_);
};
goog.inherits(proto.talk_api.AssistantMessagingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.AssistantMessagingResponse.displayName = 'proto.talk_api.AssistantMessagingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreateMessageMetricRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.CreateMessageMetricRequest.repeatedFields_, null);
};
goog.inherits(proto.talk_api.CreateMessageMetricRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreateMessageMetricRequest.displayName = 'proto.talk_api.CreateMessageMetricRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreateMessageMetricResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.CreateMessageMetricResponse.repeatedFields_, null);
};
goog.inherits(proto.talk_api.CreateMessageMetricResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreateMessageMetricResponse.displayName = 'proto.talk_api.CreateMessageMetricResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreateConversationMetricRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.CreateConversationMetricRequest.repeatedFields_, null);
};
goog.inherits(proto.talk_api.CreateConversationMetricRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreateConversationMetricRequest.displayName = 'proto.talk_api.CreateConversationMetricRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreateConversationMetricResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.CreateConversationMetricResponse.repeatedFields_, null);
};
goog.inherits(proto.talk_api.CreateConversationMetricResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreateConversationMetricResponse.displayName = 'proto.talk_api.CreateConversationMetricResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.InitiateAssistantTalkParameter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.InitiateAssistantTalkParameter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.InitiateAssistantTalkParameter.displayName = 'proto.talk_api.InitiateAssistantTalkParameter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.InitiateAssistantTalkRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.InitiateAssistantTalkRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.InitiateAssistantTalkRequest.displayName = 'proto.talk_api.InitiateAssistantTalkRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.InitiateAssistantTalkResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.InitiateAssistantTalkResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.InitiateAssistantTalkResponse.displayName = 'proto.talk_api.InitiateAssistantTalkResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.InitiateBulkAssistantTalkRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.InitiateBulkAssistantTalkRequest.repeatedFields_, null);
};
goog.inherits(proto.talk_api.InitiateBulkAssistantTalkRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.InitiateBulkAssistantTalkRequest.displayName = 'proto.talk_api.InitiateBulkAssistantTalkRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.InitiateBulkAssistantTalkResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.InitiateBulkAssistantTalkResponse.repeatedFields_, null);
};
goog.inherits(proto.talk_api.InitiateBulkAssistantTalkResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.InitiateBulkAssistantTalkResponse.displayName = 'proto.talk_api.InitiateBulkAssistantTalkResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.AssistantDefinition.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.AssistantDefinition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.AssistantDefinition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantDefinition.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    version: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.AssistantDefinition}
 */
proto.talk_api.AssistantDefinition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.AssistantDefinition;
  return proto.talk_api.AssistantDefinition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.AssistantDefinition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.AssistantDefinition}
 */
proto.talk_api.AssistantDefinition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.AssistantDefinition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.AssistantDefinition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.AssistantDefinition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantDefinition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint64 assistantId = 1;
 * @return {string}
 */
proto.talk_api.AssistantDefinition.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.AssistantDefinition} returns this
 */
proto.talk_api.AssistantDefinition.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string version = 2;
 * @return {string}
 */
proto.talk_api.AssistantDefinition.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.AssistantDefinition} returns this
 */
proto.talk_api.AssistantDefinition.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.AssistantMessagingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.AssistantMessagingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.AssistantMessagingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantMessagingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistant: (f = msg.getAssistant()) && proto.talk_api.AssistantDefinition.toObject(includeInstance, f),
    message: (f = msg.getMessage()) && common_pb.Message.toObject(includeInstance, f),
    assistantconversationid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : [],
    source: jspb.Message.getFieldWithDefault(msg, 7, 0),
    argsMap: (f = msg.getArgsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : [],
    optionsMap: (f = msg.getOptionsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.AssistantMessagingRequest}
 */
proto.talk_api.AssistantMessagingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.AssistantMessagingRequest;
  return proto.talk_api.AssistantMessagingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.AssistantMessagingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.AssistantMessagingRequest}
 */
proto.talk_api.AssistantMessagingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.talk_api.AssistantDefinition;
      reader.readMessage(value,proto.talk_api.AssistantDefinition.deserializeBinaryFromReader);
      msg.setAssistant(value);
      break;
    case 3:
      var value = new common_pb.Message;
      reader.readMessage(value,common_pb.Message.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantconversationid(value);
      break;
    case 6:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    case 7:
      var value = /** @type {!proto.Source} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 10:
      var value = msg.getArgsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    case 11:
      var value = msg.getOptionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.AssistantMessagingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.AssistantMessagingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.AssistantMessagingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantMessagingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistant();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.talk_api.AssistantDefinition.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.Message.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeUint64String(
      4,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getArgsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
  f = message.getOptionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(11, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
};


/**
 * optional AssistantDefinition assistant = 2;
 * @return {?proto.talk_api.AssistantDefinition}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getAssistant = function() {
  return /** @type{?proto.talk_api.AssistantDefinition} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.AssistantDefinition, 2));
};


/**
 * @param {?proto.talk_api.AssistantDefinition|undefined} value
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
*/
proto.talk_api.AssistantMessagingRequest.prototype.setAssistant = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.clearAssistant = function() {
  return this.setAssistant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingRequest.prototype.hasAssistant = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Message message = 3;
 * @return {?proto.Message}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getMessage = function() {
  return /** @type{?proto.Message} */ (
    jspb.Message.getWrapperField(this, common_pb.Message, 3));
};


/**
 * @param {?proto.Message|undefined} value
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
*/
proto.talk_api.AssistantMessagingRequest.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingRequest.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint64 assistantConversationId = 4;
 * @return {string}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getAssistantconversationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.setAssistantconversationid = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.clearAssistantconversationid = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingRequest.prototype.hasAssistantconversationid = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * map<string, google.protobuf.Any> metadata = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;};


/**
 * optional Source source = 7;
 * @return {!proto.Source}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getSource = function() {
  return /** @type {!proto.Source} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.Source} value
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * map<string, google.protobuf.Any> args = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getArgsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.clearArgsMap = function() {
  this.getArgsMap().clear();
  return this;};


/**
 * map<string, google.protobuf.Any> options = 11;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getOptionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 11, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.clearOptionsMap = function() {
  this.getOptionsMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.AssistantConversationConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.AssistantConversationConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.AssistantConversationConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantConversationConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantconversationid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistant: (f = msg.getAssistant()) && proto.talk_api.AssistantDefinition.toObject(includeInstance, f),
    time: (f = msg.getTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.AssistantConversationConfiguration}
 */
proto.talk_api.AssistantConversationConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.AssistantConversationConfiguration;
  return proto.talk_api.AssistantConversationConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.AssistantConversationConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.AssistantConversationConfiguration}
 */
proto.talk_api.AssistantConversationConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantconversationid(value);
      break;
    case 2:
      var value = new proto.talk_api.AssistantDefinition;
      reader.readMessage(value,proto.talk_api.AssistantDefinition.deserializeBinaryFromReader);
      msg.setAssistant(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.AssistantConversationConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.AssistantConversationConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.AssistantConversationConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantConversationConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantconversationid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistant();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.talk_api.AssistantDefinition.serializeBinaryToWriter
    );
  }
  f = message.getTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 assistantConversationId = 1;
 * @return {string}
 */
proto.talk_api.AssistantConversationConfiguration.prototype.getAssistantconversationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.AssistantConversationConfiguration} returns this
 */
proto.talk_api.AssistantConversationConfiguration.prototype.setAssistantconversationid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional AssistantDefinition assistant = 2;
 * @return {?proto.talk_api.AssistantDefinition}
 */
proto.talk_api.AssistantConversationConfiguration.prototype.getAssistant = function() {
  return /** @type{?proto.talk_api.AssistantDefinition} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.AssistantDefinition, 2));
};


/**
 * @param {?proto.talk_api.AssistantDefinition|undefined} value
 * @return {!proto.talk_api.AssistantConversationConfiguration} returns this
*/
proto.talk_api.AssistantConversationConfiguration.prototype.setAssistant = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantConversationConfiguration} returns this
 */
proto.talk_api.AssistantConversationConfiguration.prototype.clearAssistant = function() {
  return this.setAssistant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantConversationConfiguration.prototype.hasAssistant = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.talk_api.AssistantConversationConfiguration.prototype.getTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.talk_api.AssistantConversationConfiguration} returns this
*/
proto.talk_api.AssistantConversationConfiguration.prototype.setTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantConversationConfiguration} returns this
 */
proto.talk_api.AssistantConversationConfiguration.prototype.clearTime = function() {
  return this.setTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantConversationConfiguration.prototype.hasTime = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.AssistantConversationInterruption.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.AssistantConversationInterruption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.AssistantConversationInterruption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantConversationInterruption.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    time: (f = msg.getTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.AssistantConversationInterruption}
 */
proto.talk_api.AssistantConversationInterruption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.AssistantConversationInterruption;
  return proto.talk_api.AssistantConversationInterruption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.AssistantConversationInterruption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.AssistantConversationInterruption}
 */
proto.talk_api.AssistantConversationInterruption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.talk_api.AssistantConversationInterruption.InterruptionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.AssistantConversationInterruption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.AssistantConversationInterruption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.AssistantConversationInterruption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantConversationInterruption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.talk_api.AssistantConversationInterruption.InterruptionType = {
  INTERRUPTION_TYPE_UNSPECIFIED: 0,
  INTERRUPTION_TYPE_VAD: 1,
  INTERRUPTION_TYPE_WORD: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.talk_api.AssistantConversationInterruption.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.AssistantConversationInterruption} returns this
 */
proto.talk_api.AssistantConversationInterruption.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional InterruptionType type = 2;
 * @return {!proto.talk_api.AssistantConversationInterruption.InterruptionType}
 */
proto.talk_api.AssistantConversationInterruption.prototype.getType = function() {
  return /** @type {!proto.talk_api.AssistantConversationInterruption.InterruptionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.talk_api.AssistantConversationInterruption.InterruptionType} value
 * @return {!proto.talk_api.AssistantConversationInterruption} returns this
 */
proto.talk_api.AssistantConversationInterruption.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.talk_api.AssistantConversationInterruption.prototype.getTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.talk_api.AssistantConversationInterruption} returns this
*/
proto.talk_api.AssistantConversationInterruption.prototype.setTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantConversationInterruption} returns this
 */
proto.talk_api.AssistantConversationInterruption.prototype.clearTime = function() {
  return this.setTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantConversationInterruption.prototype.hasTime = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.AssistantConversationUserMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.AssistantConversationUserMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.AssistantConversationUserMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantConversationUserMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: (f = msg.getMessage()) && common_pb.Message.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    completed: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    time: (f = msg.getTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.AssistantConversationUserMessage}
 */
proto.talk_api.AssistantConversationUserMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.AssistantConversationUserMessage;
  return proto.talk_api.AssistantConversationUserMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.AssistantConversationUserMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.AssistantConversationUserMessage}
 */
proto.talk_api.AssistantConversationUserMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.Message;
      reader.readMessage(value,common_pb.Message.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCompleted(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.AssistantConversationUserMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.AssistantConversationUserMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.AssistantConversationUserMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantConversationUserMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.Message.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCompleted();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional Message message = 1;
 * @return {?proto.Message}
 */
proto.talk_api.AssistantConversationUserMessage.prototype.getMessage = function() {
  return /** @type{?proto.Message} */ (
    jspb.Message.getWrapperField(this, common_pb.Message, 1));
};


/**
 * @param {?proto.Message|undefined} value
 * @return {!proto.talk_api.AssistantConversationUserMessage} returns this
*/
proto.talk_api.AssistantConversationUserMessage.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantConversationUserMessage} returns this
 */
proto.talk_api.AssistantConversationUserMessage.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantConversationUserMessage.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.talk_api.AssistantConversationUserMessage.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.AssistantConversationUserMessage} returns this
 */
proto.talk_api.AssistantConversationUserMessage.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool completed = 3;
 * @return {boolean}
 */
proto.talk_api.AssistantConversationUserMessage.prototype.getCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.AssistantConversationUserMessage} returns this
 */
proto.talk_api.AssistantConversationUserMessage.prototype.setCompleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.talk_api.AssistantConversationUserMessage.prototype.getTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.talk_api.AssistantConversationUserMessage} returns this
*/
proto.talk_api.AssistantConversationUserMessage.prototype.setTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantConversationUserMessage} returns this
 */
proto.talk_api.AssistantConversationUserMessage.prototype.clearTime = function() {
  return this.setTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantConversationUserMessage.prototype.hasTime = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.AssistantConversationAssistantMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.AssistantConversationAssistantMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.AssistantConversationAssistantMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantConversationAssistantMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: (f = msg.getMessage()) && common_pb.Message.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    completed: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    time: (f = msg.getTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.AssistantConversationAssistantMessage}
 */
proto.talk_api.AssistantConversationAssistantMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.AssistantConversationAssistantMessage;
  return proto.talk_api.AssistantConversationAssistantMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.AssistantConversationAssistantMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.AssistantConversationAssistantMessage}
 */
proto.talk_api.AssistantConversationAssistantMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.Message;
      reader.readMessage(value,common_pb.Message.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCompleted(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.AssistantConversationAssistantMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.AssistantConversationAssistantMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.AssistantConversationAssistantMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantConversationAssistantMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.Message.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCompleted();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional Message message = 1;
 * @return {?proto.Message}
 */
proto.talk_api.AssistantConversationAssistantMessage.prototype.getMessage = function() {
  return /** @type{?proto.Message} */ (
    jspb.Message.getWrapperField(this, common_pb.Message, 1));
};


/**
 * @param {?proto.Message|undefined} value
 * @return {!proto.talk_api.AssistantConversationAssistantMessage} returns this
*/
proto.talk_api.AssistantConversationAssistantMessage.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantConversationAssistantMessage} returns this
 */
proto.talk_api.AssistantConversationAssistantMessage.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantConversationAssistantMessage.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.talk_api.AssistantConversationAssistantMessage.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.AssistantConversationAssistantMessage} returns this
 */
proto.talk_api.AssistantConversationAssistantMessage.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool completed = 3;
 * @return {boolean}
 */
proto.talk_api.AssistantConversationAssistantMessage.prototype.getCompleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.AssistantConversationAssistantMessage} returns this
 */
proto.talk_api.AssistantConversationAssistantMessage.prototype.setCompleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.talk_api.AssistantConversationAssistantMessage.prototype.getTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.talk_api.AssistantConversationAssistantMessage} returns this
*/
proto.talk_api.AssistantConversationAssistantMessage.prototype.setTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantConversationAssistantMessage} returns this
 */
proto.talk_api.AssistantConversationAssistantMessage.prototype.clearTime = function() {
  return this.setTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantConversationAssistantMessage.prototype.hasTime = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.talk_api.AssistantMessagingResponse.oneofGroups_ = [[9,10,11,12,13]];

/**
 * @enum {number}
 */
proto.talk_api.AssistantMessagingResponse.DataCase = {
  DATA_NOT_SET: 0,
  CONFIGURATION: 9,
  INTERRUPTION: 10,
  USER: 11,
  ASSISTANT: 12,
  MESSAGE: 13
};

/**
 * @return {proto.talk_api.AssistantMessagingResponse.DataCase}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getDataCase = function() {
  return /** @type {proto.talk_api.AssistantMessagingResponse.DataCase} */(jspb.Message.computeOneofCase(this, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.AssistantMessagingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.AssistantMessagingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.AssistantMessagingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantMessagingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    configuration: (f = msg.getConfiguration()) && proto.talk_api.AssistantConversationConfiguration.toObject(includeInstance, f),
    interruption: (f = msg.getInterruption()) && proto.talk_api.AssistantConversationInterruption.toObject(includeInstance, f),
    user: (f = msg.getUser()) && proto.talk_api.AssistantConversationUserMessage.toObject(includeInstance, f),
    assistant: (f = msg.getAssistant()) && proto.talk_api.AssistantConversationAssistantMessage.toObject(includeInstance, f),
    message: (f = msg.getMessage()) && common_pb.AssistantConversationMessage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.AssistantMessagingResponse}
 */
proto.talk_api.AssistantMessagingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.AssistantMessagingResponse;
  return proto.talk_api.AssistantMessagingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.AssistantMessagingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.AssistantMessagingResponse}
 */
proto.talk_api.AssistantMessagingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 9:
      var value = new proto.talk_api.AssistantConversationConfiguration;
      reader.readMessage(value,proto.talk_api.AssistantConversationConfiguration.deserializeBinaryFromReader);
      msg.setConfiguration(value);
      break;
    case 10:
      var value = new proto.talk_api.AssistantConversationInterruption;
      reader.readMessage(value,proto.talk_api.AssistantConversationInterruption.deserializeBinaryFromReader);
      msg.setInterruption(value);
      break;
    case 11:
      var value = new proto.talk_api.AssistantConversationUserMessage;
      reader.readMessage(value,proto.talk_api.AssistantConversationUserMessage.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 12:
      var value = new proto.talk_api.AssistantConversationAssistantMessage;
      reader.readMessage(value,proto.talk_api.AssistantConversationAssistantMessage.deserializeBinaryFromReader);
      msg.setAssistant(value);
      break;
    case 13:
      var value = new common_pb.AssistantConversationMessage;
      reader.readMessage(value,common_pb.AssistantConversationMessage.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.AssistantMessagingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.AssistantMessagingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.AssistantMessagingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantMessagingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getConfiguration();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.talk_api.AssistantConversationConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getInterruption();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.talk_api.AssistantConversationInterruption.serializeBinaryToWriter
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.talk_api.AssistantConversationUserMessage.serializeBinaryToWriter
    );
  }
  f = message.getAssistant();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.talk_api.AssistantConversationAssistantMessage.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      common_pb.AssistantConversationMessage.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional AssistantConversationConfiguration configuration = 9;
 * @return {?proto.talk_api.AssistantConversationConfiguration}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getConfiguration = function() {
  return /** @type{?proto.talk_api.AssistantConversationConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.AssistantConversationConfiguration, 9));
};


/**
 * @param {?proto.talk_api.AssistantConversationConfiguration|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setConfiguration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearConfiguration = function() {
  return this.setConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasConfiguration = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional AssistantConversationInterruption interruption = 10;
 * @return {?proto.talk_api.AssistantConversationInterruption}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getInterruption = function() {
  return /** @type{?proto.talk_api.AssistantConversationInterruption} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.AssistantConversationInterruption, 10));
};


/**
 * @param {?proto.talk_api.AssistantConversationInterruption|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setInterruption = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearInterruption = function() {
  return this.setInterruption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasInterruption = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional AssistantConversationUserMessage user = 11;
 * @return {?proto.talk_api.AssistantConversationUserMessage}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getUser = function() {
  return /** @type{?proto.talk_api.AssistantConversationUserMessage} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.AssistantConversationUserMessage, 11));
};


/**
 * @param {?proto.talk_api.AssistantConversationUserMessage|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setUser = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasUser = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional AssistantConversationAssistantMessage assistant = 12;
 * @return {?proto.talk_api.AssistantConversationAssistantMessage}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getAssistant = function() {
  return /** @type{?proto.talk_api.AssistantConversationAssistantMessage} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.AssistantConversationAssistantMessage, 12));
};


/**
 * @param {?proto.talk_api.AssistantConversationAssistantMessage|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setAssistant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearAssistant = function() {
  return this.setAssistant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasAssistant = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional AssistantConversationMessage message = 13;
 * @return {?proto.AssistantConversationMessage}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getMessage = function() {
  return /** @type{?proto.AssistantConversationMessage} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConversationMessage, 13));
};


/**
 * @param {?proto.AssistantConversationMessage|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setMessage = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 13) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.CreateMessageMetricRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreateMessageMetricRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreateMessageMetricRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateMessageMetricRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantconversationid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    messageid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    metricsList: jspb.Message.toObjectList(msg.getMetricsList(),
    common_pb.Metric.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreateMessageMetricRequest}
 */
proto.talk_api.CreateMessageMetricRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreateMessageMetricRequest;
  return proto.talk_api.CreateMessageMetricRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreateMessageMetricRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreateMessageMetricRequest}
 */
proto.talk_api.CreateMessageMetricRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantconversationid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessageid(value);
      break;
    case 4:
      var value = new common_pb.Metric;
      reader.readMessage(value,common_pb.Metric.deserializeBinaryFromReader);
      msg.addMetrics(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreateMessageMetricRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreateMessageMetricRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateMessageMetricRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantconversationid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getMessageid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMetricsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      common_pb.Metric.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 assistantId = 1;
 * @return {string}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
 */
proto.talk_api.CreateMessageMetricRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantConversationId = 2;
 * @return {string}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.getAssistantconversationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
 */
proto.talk_api.CreateMessageMetricRequest.prototype.setAssistantconversationid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string messageId = 3;
 * @return {string}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.getMessageid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
 */
proto.talk_api.CreateMessageMetricRequest.prototype.setMessageid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated Metric metrics = 4;
 * @return {!Array<!proto.Metric>}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.getMetricsList = function() {
  return /** @type{!Array<!proto.Metric>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metric, 4));
};


/**
 * @param {!Array<!proto.Metric>} value
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
*/
proto.talk_api.CreateMessageMetricRequest.prototype.setMetricsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Metric=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metric}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.addMetrics = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Metric, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
 */
proto.talk_api.CreateMessageMetricRequest.prototype.clearMetricsList = function() {
  return this.setMetricsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.CreateMessageMetricResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreateMessageMetricResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreateMessageMetricResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateMessageMetricResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    common_pb.Metric.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreateMessageMetricResponse}
 */
proto.talk_api.CreateMessageMetricResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreateMessageMetricResponse;
  return proto.talk_api.CreateMessageMetricResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreateMessageMetricResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreateMessageMetricResponse}
 */
proto.talk_api.CreateMessageMetricResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new common_pb.Metric;
      reader.readMessage(value,common_pb.Metric.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreateMessageMetricResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreateMessageMetricResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateMessageMetricResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Metric.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
 */
proto.talk_api.CreateMessageMetricResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
 */
proto.talk_api.CreateMessageMetricResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated Metric data = 3;
 * @return {!Array<!proto.Metric>}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.Metric>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metric, 3));
};


/**
 * @param {!Array<!proto.Metric>} value
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
*/
proto.talk_api.CreateMessageMetricResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Metric=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metric}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Metric, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
 */
proto.talk_api.CreateMessageMetricResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
*/
proto.talk_api.CreateMessageMetricResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
 */
proto.talk_api.CreateMessageMetricResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.CreateConversationMetricRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreateConversationMetricRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreateConversationMetricRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateConversationMetricRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantconversationid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    metricsList: jspb.Message.toObjectList(msg.getMetricsList(),
    common_pb.Metric.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreateConversationMetricRequest}
 */
proto.talk_api.CreateConversationMetricRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreateConversationMetricRequest;
  return proto.talk_api.CreateConversationMetricRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreateConversationMetricRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreateConversationMetricRequest}
 */
proto.talk_api.CreateConversationMetricRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantconversationid(value);
      break;
    case 3:
      var value = new common_pb.Metric;
      reader.readMessage(value,common_pb.Metric.deserializeBinaryFromReader);
      msg.addMetrics(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreateConversationMetricRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreateConversationMetricRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateConversationMetricRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantconversationid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getMetricsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Metric.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 assistantId = 1;
 * @return {string}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateConversationMetricRequest} returns this
 */
proto.talk_api.CreateConversationMetricRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantConversationId = 2;
 * @return {string}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.getAssistantconversationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateConversationMetricRequest} returns this
 */
proto.talk_api.CreateConversationMetricRequest.prototype.setAssistantconversationid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * repeated Metric metrics = 3;
 * @return {!Array<!proto.Metric>}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.getMetricsList = function() {
  return /** @type{!Array<!proto.Metric>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metric, 3));
};


/**
 * @param {!Array<!proto.Metric>} value
 * @return {!proto.talk_api.CreateConversationMetricRequest} returns this
*/
proto.talk_api.CreateConversationMetricRequest.prototype.setMetricsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Metric=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metric}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.addMetrics = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Metric, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.CreateConversationMetricRequest} returns this
 */
proto.talk_api.CreateConversationMetricRequest.prototype.clearMetricsList = function() {
  return this.setMetricsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.CreateConversationMetricResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreateConversationMetricResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreateConversationMetricResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateConversationMetricResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    common_pb.Metric.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreateConversationMetricResponse}
 */
proto.talk_api.CreateConversationMetricResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreateConversationMetricResponse;
  return proto.talk_api.CreateConversationMetricResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreateConversationMetricResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreateConversationMetricResponse}
 */
proto.talk_api.CreateConversationMetricResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new common_pb.Metric;
      reader.readMessage(value,common_pb.Metric.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreateConversationMetricResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreateConversationMetricResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateConversationMetricResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Metric.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
 */
proto.talk_api.CreateConversationMetricResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
 */
proto.talk_api.CreateConversationMetricResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated Metric data = 3;
 * @return {!Array<!proto.Metric>}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.Metric>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metric, 3));
};


/**
 * @param {!Array<!proto.Metric>} value
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
*/
proto.talk_api.CreateConversationMetricResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Metric=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metric}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Metric, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
 */
proto.talk_api.CreateConversationMetricResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
*/
proto.talk_api.CreateConversationMetricResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
 */
proto.talk_api.CreateConversationMetricResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.InitiateAssistantTalkParameter.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.InitiateAssistantTalkParameter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.InitiateAssistantTalkParameter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.InitiateAssistantTalkParameter.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsMap: (f = msg.getItemsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.InitiateAssistantTalkParameter}
 */
proto.talk_api.InitiateAssistantTalkParameter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.InitiateAssistantTalkParameter;
  return proto.talk_api.InitiateAssistantTalkParameter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.InitiateAssistantTalkParameter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.InitiateAssistantTalkParameter}
 */
proto.talk_api.InitiateAssistantTalkParameter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getItemsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.InitiateAssistantTalkParameter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.InitiateAssistantTalkParameter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.InitiateAssistantTalkParameter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.InitiateAssistantTalkParameter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
};


/**
 * map<string, google.protobuf.Any> items = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.InitiateAssistantTalkParameter.prototype.getItemsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.InitiateAssistantTalkParameter} returns this
 */
proto.talk_api.InitiateAssistantTalkParameter.prototype.clearItemsMap = function() {
  this.getItemsMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.InitiateAssistantTalkRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.InitiateAssistantTalkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.InitiateAssistantTalkRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistant: (f = msg.getAssistant()) && proto.talk_api.AssistantDefinition.toObject(includeInstance, f),
    source: jspb.Message.getFieldWithDefault(msg, 2, 0),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : [],
    argsMap: (f = msg.getArgsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : [],
    optionsMap: (f = msg.getOptionsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : [],
    params: (f = msg.getParams()) && proto.talk_api.InitiateAssistantTalkParameter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.InitiateAssistantTalkRequest}
 */
proto.talk_api.InitiateAssistantTalkRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.InitiateAssistantTalkRequest;
  return proto.talk_api.InitiateAssistantTalkRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.InitiateAssistantTalkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.InitiateAssistantTalkRequest}
 */
proto.talk_api.InitiateAssistantTalkRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.talk_api.AssistantDefinition;
      reader.readMessage(value,proto.talk_api.AssistantDefinition.deserializeBinaryFromReader);
      msg.setAssistant(value);
      break;
    case 2:
      var value = /** @type {!proto.Source} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 3:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    case 4:
      var value = msg.getArgsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    case 5:
      var value = msg.getOptionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    case 6:
      var value = new proto.talk_api.InitiateAssistantTalkParameter;
      reader.readMessage(value,proto.talk_api.InitiateAssistantTalkParameter.deserializeBinaryFromReader);
      msg.setParams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.InitiateAssistantTalkRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.InitiateAssistantTalkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.InitiateAssistantTalkRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistant();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.talk_api.AssistantDefinition.serializeBinaryToWriter
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
  f = message.getArgsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
  f = message.getOptionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
  f = message.getParams();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.talk_api.InitiateAssistantTalkParameter.serializeBinaryToWriter
    );
  }
};


/**
 * optional AssistantDefinition assistant = 1;
 * @return {?proto.talk_api.AssistantDefinition}
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.getAssistant = function() {
  return /** @type{?proto.talk_api.AssistantDefinition} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.AssistantDefinition, 1));
};


/**
 * @param {?proto.talk_api.AssistantDefinition|undefined} value
 * @return {!proto.talk_api.InitiateAssistantTalkRequest} returns this
*/
proto.talk_api.InitiateAssistantTalkRequest.prototype.setAssistant = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.InitiateAssistantTalkRequest} returns this
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.clearAssistant = function() {
  return this.setAssistant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.hasAssistant = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Source source = 2;
 * @return {!proto.Source}
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.getSource = function() {
  return /** @type {!proto.Source} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Source} value
 * @return {!proto.talk_api.InitiateAssistantTalkRequest} returns this
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * map<string, google.protobuf.Any> metadata = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.InitiateAssistantTalkRequest} returns this
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;};


/**
 * map<string, google.protobuf.Any> args = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.getArgsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.InitiateAssistantTalkRequest} returns this
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.clearArgsMap = function() {
  this.getArgsMap().clear();
  return this;};


/**
 * map<string, google.protobuf.Any> options = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.getOptionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.InitiateAssistantTalkRequest} returns this
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.clearOptionsMap = function() {
  this.getOptionsMap().clear();
  return this;};


/**
 * optional InitiateAssistantTalkParameter params = 6;
 * @return {?proto.talk_api.InitiateAssistantTalkParameter}
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.getParams = function() {
  return /** @type{?proto.talk_api.InitiateAssistantTalkParameter} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.InitiateAssistantTalkParameter, 6));
};


/**
 * @param {?proto.talk_api.InitiateAssistantTalkParameter|undefined} value
 * @return {!proto.talk_api.InitiateAssistantTalkRequest} returns this
*/
proto.talk_api.InitiateAssistantTalkRequest.prototype.setParams = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.InitiateAssistantTalkRequest} returns this
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.clearParams = function() {
  return this.setParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.InitiateAssistantTalkRequest.prototype.hasParams = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.InitiateAssistantTalkResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.InitiateAssistantTalkResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.InitiateAssistantTalkResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.InitiateAssistantTalkResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.talk_api.InitiateAssistantTalkParameter.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.InitiateAssistantTalkResponse}
 */
proto.talk_api.InitiateAssistantTalkResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.InitiateAssistantTalkResponse;
  return proto.talk_api.InitiateAssistantTalkResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.InitiateAssistantTalkResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.InitiateAssistantTalkResponse}
 */
proto.talk_api.InitiateAssistantTalkResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.talk_api.InitiateAssistantTalkParameter;
      reader.readMessage(value,proto.talk_api.InitiateAssistantTalkParameter.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.InitiateAssistantTalkResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.InitiateAssistantTalkResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.InitiateAssistantTalkResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.InitiateAssistantTalkResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.talk_api.InitiateAssistantTalkParameter.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.talk_api.InitiateAssistantTalkResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.InitiateAssistantTalkResponse} returns this
 */
proto.talk_api.InitiateAssistantTalkResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.talk_api.InitiateAssistantTalkResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.InitiateAssistantTalkResponse} returns this
 */
proto.talk_api.InitiateAssistantTalkResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional InitiateAssistantTalkParameter data = 3;
 * @return {?proto.talk_api.InitiateAssistantTalkParameter}
 */
proto.talk_api.InitiateAssistantTalkResponse.prototype.getData = function() {
  return /** @type{?proto.talk_api.InitiateAssistantTalkParameter} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.InitiateAssistantTalkParameter, 3));
};


/**
 * @param {?proto.talk_api.InitiateAssistantTalkParameter|undefined} value
 * @return {!proto.talk_api.InitiateAssistantTalkResponse} returns this
*/
proto.talk_api.InitiateAssistantTalkResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.InitiateAssistantTalkResponse} returns this
 */
proto.talk_api.InitiateAssistantTalkResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.InitiateAssistantTalkResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.talk_api.InitiateAssistantTalkResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.talk_api.InitiateAssistantTalkResponse} returns this
*/
proto.talk_api.InitiateAssistantTalkResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.InitiateAssistantTalkResponse} returns this
 */
proto.talk_api.InitiateAssistantTalkResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.InitiateAssistantTalkResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.InitiateBulkAssistantTalkRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.InitiateBulkAssistantTalkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistant: (f = msg.getAssistant()) && proto.talk_api.AssistantDefinition.toObject(includeInstance, f),
    source: jspb.Message.getFieldWithDefault(msg, 2, 0),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : [],
    argsMap: (f = msg.getArgsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : [],
    optionsMap: (f = msg.getOptionsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : [],
    paramsList: jspb.Message.toObjectList(msg.getParamsList(),
    proto.talk_api.InitiateAssistantTalkParameter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.InitiateBulkAssistantTalkRequest}
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.InitiateBulkAssistantTalkRequest;
  return proto.talk_api.InitiateBulkAssistantTalkRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.InitiateBulkAssistantTalkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.InitiateBulkAssistantTalkRequest}
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.talk_api.AssistantDefinition;
      reader.readMessage(value,proto.talk_api.AssistantDefinition.deserializeBinaryFromReader);
      msg.setAssistant(value);
      break;
    case 2:
      var value = /** @type {!proto.Source} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 3:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    case 4:
      var value = msg.getArgsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    case 5:
      var value = msg.getOptionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    case 6:
      var value = new proto.talk_api.InitiateAssistantTalkParameter;
      reader.readMessage(value,proto.talk_api.InitiateAssistantTalkParameter.deserializeBinaryFromReader);
      msg.addParams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.InitiateBulkAssistantTalkRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.InitiateBulkAssistantTalkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistant();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.talk_api.AssistantDefinition.serializeBinaryToWriter
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
  f = message.getArgsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
  f = message.getOptionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
  f = message.getParamsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.talk_api.InitiateAssistantTalkParameter.serializeBinaryToWriter
    );
  }
};


/**
 * optional AssistantDefinition assistant = 1;
 * @return {?proto.talk_api.AssistantDefinition}
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.getAssistant = function() {
  return /** @type{?proto.talk_api.AssistantDefinition} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.AssistantDefinition, 1));
};


/**
 * @param {?proto.talk_api.AssistantDefinition|undefined} value
 * @return {!proto.talk_api.InitiateBulkAssistantTalkRequest} returns this
*/
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.setAssistant = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.InitiateBulkAssistantTalkRequest} returns this
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.clearAssistant = function() {
  return this.setAssistant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.hasAssistant = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Source source = 2;
 * @return {!proto.Source}
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.getSource = function() {
  return /** @type {!proto.Source} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Source} value
 * @return {!proto.talk_api.InitiateBulkAssistantTalkRequest} returns this
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * map<string, google.protobuf.Any> metadata = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.InitiateBulkAssistantTalkRequest} returns this
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;};


/**
 * map<string, google.protobuf.Any> args = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.getArgsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.InitiateBulkAssistantTalkRequest} returns this
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.clearArgsMap = function() {
  this.getArgsMap().clear();
  return this;};


/**
 * map<string, google.protobuf.Any> options = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.getOptionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.InitiateBulkAssistantTalkRequest} returns this
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.clearOptionsMap = function() {
  this.getOptionsMap().clear();
  return this;};


/**
 * repeated InitiateAssistantTalkParameter params = 6;
 * @return {!Array<!proto.talk_api.InitiateAssistantTalkParameter>}
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.getParamsList = function() {
  return /** @type{!Array<!proto.talk_api.InitiateAssistantTalkParameter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.talk_api.InitiateAssistantTalkParameter, 6));
};


/**
 * @param {!Array<!proto.talk_api.InitiateAssistantTalkParameter>} value
 * @return {!proto.talk_api.InitiateBulkAssistantTalkRequest} returns this
*/
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.setParamsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.talk_api.InitiateAssistantTalkParameter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.talk_api.InitiateAssistantTalkParameter}
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.addParams = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.talk_api.InitiateAssistantTalkParameter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.InitiateBulkAssistantTalkRequest} returns this
 */
proto.talk_api.InitiateBulkAssistantTalkRequest.prototype.clearParamsList = function() {
  return this.setParamsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.InitiateBulkAssistantTalkResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.InitiateBulkAssistantTalkResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.talk_api.InitiateAssistantTalkParameter.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.InitiateBulkAssistantTalkResponse}
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.InitiateBulkAssistantTalkResponse;
  return proto.talk_api.InitiateBulkAssistantTalkResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.InitiateBulkAssistantTalkResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.InitiateBulkAssistantTalkResponse}
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.talk_api.InitiateAssistantTalkParameter;
      reader.readMessage(value,proto.talk_api.InitiateAssistantTalkParameter.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.InitiateBulkAssistantTalkResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.InitiateBulkAssistantTalkResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.talk_api.InitiateAssistantTalkParameter.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.InitiateBulkAssistantTalkResponse} returns this
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.InitiateBulkAssistantTalkResponse} returns this
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated InitiateAssistantTalkParameter data = 3;
 * @return {!Array<!proto.talk_api.InitiateAssistantTalkParameter>}
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.talk_api.InitiateAssistantTalkParameter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.talk_api.InitiateAssistantTalkParameter, 3));
};


/**
 * @param {!Array<!proto.talk_api.InitiateAssistantTalkParameter>} value
 * @return {!proto.talk_api.InitiateBulkAssistantTalkResponse} returns this
*/
proto.talk_api.InitiateBulkAssistantTalkResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.talk_api.InitiateAssistantTalkParameter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.talk_api.InitiateAssistantTalkParameter}
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.talk_api.InitiateAssistantTalkParameter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.InitiateBulkAssistantTalkResponse} returns this
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.talk_api.InitiateBulkAssistantTalkResponse} returns this
*/
proto.talk_api.InitiateBulkAssistantTalkResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.InitiateBulkAssistantTalkResponse} returns this
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.InitiateBulkAssistantTalkResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.talk_api);
